
import { Payroll4AssistantController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * AI assitant for payroll.
 * @example
 * ```html
 * <salaxy-payroll-assistant model="$ctrl.current"></salaxy-payroll-assistant>
 * ```
 */
export class PayrollAssistant extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {
    /** Current payroll to assist */
    current: "<",

    /** Current page */
    page: "<",
  };

  /** Uses the PayrollCrudController */
  public controller = Payroll4AssistantController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/calc/payrollV4/PayrollAssistant.html";
}
